import { Page } from 'layouts/Page';
import { FC } from 'react';
import { Refunds } from 'components/Refunds';

export const RefundsPage: FC = () => {
	return (
		<Page title="Refunds – EAS Dashboard">
			<Refunds />
		</Page>
	);
};
